import { AppError } from '../api/errors.js';

export type ScenarioErrorCategory =
  | 'authorization'
  | 'cancelled'
  | 'conflict'
  | 'network'
  | 'not_found'
  | 'server'
  | 'throttled'
  | 'unknown'
  | 'validation';

export interface ScenarioErrorClassification {
  status: 'abandoned' | 'failure';
  data: {
    'Usage.ErrorCategory': ScenarioErrorCategory;
  };
}

export function classifyScenarioError(
  error: unknown,
): ScenarioErrorClassification {
  const category = getScenarioErrorCategory(error);
  return {
    status: category === 'cancelled' ? 'abandoned' : 'failure',
    data: { 'Usage.ErrorCategory': category },
  };
}

function getScenarioErrorCategory(error: unknown): ScenarioErrorCategory {
  if (error instanceof DOMException && error.name === 'AbortError') {
    return 'cancelled';
  }
  if (error instanceof AppError) {
    if (error.code === 'NETWORK_ERROR') return 'network';
    const status = error.statusCode;
    if (status === 401 || status === 403) return 'authorization';
    if (status === 404) return 'not_found';
    if (status === 409) return 'conflict';
    if (status === 429) return 'throttled';
    if (status !== undefined && status >= 500) return 'server';
    if (status !== undefined && status >= 400) return 'validation';
  }
  return 'unknown';
}
